import { render, staticRenderFns } from "./BasicSettings.vue?vue&type=template&id=baa54420&scoped=true&lang=html&"
import script from "./BasicSettings.vue?vue&type=script&lang=js&"
export * from "./BasicSettings.vue?vue&type=script&lang=js&"
import style0 from "./BasicSettings.vue?vue&type=style&index=0&id=baa54420&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baa54420",
  null
  
)

export default component.exports